var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7822 10.7077L12.9398 5.27692C12.4404 4.90769 11.5915 4.90769 11.0922 5.27692L5.19974 10.7538C5 10.8462 4.95006 11.0769 5.04994 11.2615C5.09987 11.4462 5.29961 11.5385 5.49936 11.5385H5.99871V16.8C5.99871 17.4923 6.54801 18 7.29704 18H10.4929C10.7925 18 10.9923 17.8154 10.9923 17.5385V15.4154C10.9923 15.0923 11.5416 14.7692 11.991 14.7692C12.4404 14.7692 13.0396 15.0923 13.0396 15.4154V17.5385C13.0396 17.8154 13.2394 18 13.539 18H16.7848C17.5339 18 18.0332 17.5385 18.0332 16.8V11.5385H18.5326C18.7323 11.5385 18.9321 11.4 18.982 11.2154C19.0319 11.0308 18.982 10.8462 18.7822 10.7077Z",
    fill: "#97B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.9cb35fa9cf5ad31f551b660700610562.svg";
export { ForwardRef as ReactComponent };